import { ConfigProviderProps } from 'antd';
import frFR from 'antd/locale/fr_FR';
import cssVar from 'utils/cssVar';

// Use a function instead of an object to execute `cssVar` at render time, not at build time
const antdConfig: () => ConfigProviderProps = () => ({
  locale: frFR,
  input: {
    className: 'input-override',
  },
  textArea: {
    className: 'textarea-override',
  },
  theme: {
    cssVar: { key: 'app' },
    token: {
      fontFamily: 'Fieldwork, sans-serif',
      colorPrimary: cssVar('--primary'),
      colorPrimaryBg: cssVar('--primary-bg'),
      colorPrimaryBgHover: cssVar('--primary-bg-hover'),
      colorPrimaryBorder: cssVar('--primary-border'),
      colorPrimaryBorderHover: cssVar('--primary-border-hover'),
      colorPrimaryHover: cssVar('--primary-hover'),
      colorPrimaryActive: cssVar('--primary-active'),
      colorPrimaryText: cssVar('--primary-text'),
      colorPrimaryTextActive: cssVar('--primary-text-active'),
      colorPrimaryTextHover: cssVar('--primary-text-hover'),
      colorSuccess: cssVar('--success'),
      colorSuccessBg: cssVar('--success-bg'),
      colorSuccessBgHover: cssVar('--success-bg-hover'),
      colorSuccessBorder: cssVar('--success-border'),
      colorSuccessBorderHover: cssVar('--success-border-hover'),
      colorSuccessHover: cssVar('--success-hover'),
      colorSuccessActive: cssVar('--success-active'),
      colorSuccessText: cssVar('--success-text'),
      colorSuccessTextActive: cssVar('--success-text-active'),
      colorSuccessTextHover: cssVar('--success-text-hover'),
      colorWarning: cssVar('--warning'),
      colorWarningBg: cssVar('--warning-bg'),
      colorWarningBgHover: cssVar('--warning-bg-hover'),
      colorWarningBorder: cssVar('--warning-border'),
      colorWarningBorderHover: cssVar('--warning-border-hover'),
      colorWarningHover: cssVar('--warning-hover'),
      colorWarningActive: cssVar('--warning-active'),
      colorWarningText: cssVar('--warning-text'),
      colorWarningTextActive: cssVar('--warning-text-active'),
      colorWarningTextHover: cssVar('--warning-text-hover'),
      colorError: cssVar('--error'),
      colorErrorBg: cssVar('--error-bg'),
      colorErrorBgHover: cssVar('--error-bg-hover'),
      colorErrorBorder: cssVar('--error-border'),
      colorErrorBorderHover: cssVar('--error-border-hover'),
      colorErrorHover: cssVar('--error-hover'),
      colorErrorActive: cssVar('--error-active'),
      colorErrorText: cssVar('--error-text'),
      colorErrorTextActive: cssVar('--error-text-active'),
      colorErrorTextHover: cssVar('--error-text-hover'),
      colorLink: cssVar('--link'),
      colorLinkHover: cssVar('--link-hover'),
      colorLinkActive: cssVar('--link-active'),
      colorHighlight: cssVar('--highlight'),
      colorText: cssVar('--text'),
      colorTextSecondary: cssVar('--text-secondary'),
      colorTextTertiary: cssVar('--text-tertiary'),
      colorTextQuaternary: cssVar('--text-quaternary'),
      colorBorder: cssVar('--border'),
      colorBorderSecondary: cssVar('--border-secondary'),
      colorFill: cssVar('--fill'),
      colorFillSecondary: cssVar('--fill-secondary'),
      colorFillTertiary: cssVar('--fill-tertiary'),
      colorFillQuaternary: cssVar('--fill-quaternary'),
      colorBgContainer: cssVar('--container'),
      colorBgElevated: cssVar('--elevated'),
      colorBgLayout: cssVar('--layout'),
      colorBgSpotlight: cssVar('--spotlight'),
      colorBgMask: cssVar('--mask'),
      boxShadow:
        '0px 1px 2px 0px rgba(0, 0, 0, 0.03), 0px 1px 6px -1px rgba(0, 0, 0, 0.02), 0px 2px 4px 0px rgba(0, 0, 0, 0.02)',
    },
    components: {
      Menu: {
        darkItemBg: cssVar('--blue-enterprise-6'),
        darkItemColor: cssVar('--background'),
        darkItemSelectedBg: cssVar('--blue-enterprise-9'),
        darkItemHoverBg: cssVar('--blue-enterprise-7'),
        itemMarginBlock: 8,
        activeBarBorderWidth: 0,
        itemBorderRadius: 4,
      },
      Table: {
        headerBg: cssVar('--background'),
        rowHoverBg: cssVar('--blue-1'),
      },
      Badge: {
        textFontSizeSM: 10,
      },
    },
  },
});

export default antdConfig;
